"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommerceHubApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var CommerceHubApi = /** @class */ (function (_super) {
    __extends(CommerceHubApi, _super);
    function CommerceHubApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommerceHubApi.prototype.commerceHubBlobsCreateUploadBlobSasUrlsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerCreateUploadBlobSasUrlsRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerCreateUploadBlobSasUrlsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Blobs/CreateUploadBlobSasUrls',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerCreateUploadBlobSasUrlsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCartsClearCartPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerClearCartRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerClearCartRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Carts/ClearCart',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerClearCartRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCartsGetCalculatedCartPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetCalculatedCartRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetCalculatedCartRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Carts/GetCalculatedCart',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetCalculatedCartRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCartsGetCartPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetCartRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetCartRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Carts/GetCart',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetCartRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCartsGetUserCartsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetUserCartsRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetUserCartsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Carts/GetUserCarts',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetUserCartsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCartsUpdateCartItemPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerUpdateCartItemRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerUpdateCartItemRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Carts/UpdateCartItem',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerUpdateCartItemRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCartsUpdateCartPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerUpdateCartRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerUpdateCartRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Carts/UpdateCart',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerUpdateCartRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCategoriesCreateCategoryPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerCreateCategoryRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerCreateCategoryRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Categories/CreateCategory',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerCreateCategoryRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCategoriesDeleteCategoryPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerDeleteCategoryRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerDeleteCategoryRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Categories/DeleteCategory',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerDeleteCategoryRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCategoriesGetCategoriesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetCategoriesRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetCategoriesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Categories/GetCategories',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetCategoriesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCategoriesSearchCategoriesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerSearchCategoriesRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerSearchCategoriesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Categories/SearchCategories',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerSearchCategoriesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCategoriesUpdateCategoryPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerUpdateCategoryRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerUpdateCategoryRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Categories/UpdateCategory',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerUpdateCategoryRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCurrenciesGetCurrenciesPost = function (_a, opts) {
        var body = _a.body;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Currencies/GetCurrencies',
            method: 'POST',
            headers: headers,
            body: body,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCurrenciesGetSupportedCurrenciesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetSupportedCurrenciesRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetSupportedCurrenciesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Currencies/GetSupportedCurrencies',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetSupportedCurrenciesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCustomCatalogsGetCsvTemplateGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/CommerceHub/CustomCatalogs/GetCsvTemplate',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCustomCatalogsGetCsvTemplateSampleGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/CommerceHub/CustomCatalogs/GetCsvTemplateSample',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCustomCatalogsGetCustomCatalogFilesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetCustomCatalogFilesRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetCustomCatalogFilesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/CustomCatalogs/GetCustomCatalogFiles',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetCustomCatalogFilesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubCustomCatalogsProcessCustomCatalogCsvPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerProcessCustomCatalogCsvRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerProcessCustomCatalogCsvRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/CustomCatalogs/ProcessCustomCatalogCsv',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerProcessCustomCatalogCsvRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubGetCustomCatalogLimitsPost = function (_a, opts) {
        var body = _a.body;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/GetCustomCatalogLimits',
            method: 'POST',
            headers: headers,
            body: body,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubLanguagesGetLanguagesPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/CommerceHub/Languages/GetLanguages',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubOrdersCreateDraftOrderPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerCreateDraftOrderRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerCreateDraftOrderRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Orders/CreateDraftOrder',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerCreateDraftOrderRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubOrdersGetMyUserOrdersPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/CommerceHub/Orders/GetMyUserOrders',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubOrdersGetUserOrdersPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetUserOrdersRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetUserOrdersRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Orders/GetUserOrders',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetUserOrdersRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubOrdersUpdateOrderPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerUpdateOrderRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerUpdateOrderRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Orders/UpdateOrder',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerUpdateOrderRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubPaymentProviderConfigsCreateStripeConnectPaymentProviderConfigPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerCreateStripeConnectPaymentProviderConfigRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerCreateStripeConnectPaymentProviderConfigRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/PaymentProviderConfigs/CreateStripeConnectPaymentProviderConfig',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerCreateStripeConnectPaymentProviderConfigRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubPaymentProviderConfigsCreateStripePaymentProviderConfigPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerCreateStripePaymentProviderConfigRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerCreateStripePaymentProviderConfigRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/PaymentProviderConfigs/CreateStripePaymentProviderConfig',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerCreateStripePaymentProviderConfigRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubPaymentProviderConfigsDeletePaymentProviderConfigPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerDeletePaymentProviderConfigRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerDeletePaymentProviderConfigRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/PaymentProviderConfigs/DeletePaymentProviderConfig',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerDeletePaymentProviderConfigRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubPaymentProviderConfigsGetPaymentProviderConfigsPost = function (_a, opts) {
        var body = _a.body;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/PaymentProviderConfigs/GetPaymentProviderConfigs',
            method: 'POST',
            headers: headers,
            body: body,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubPaymentProviderConfigsLinkPaymentProviderConfigPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerLinkPaymentProviderConfigRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerLinkPaymentProviderConfigRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/PaymentProviderConfigs/LinkPaymentProviderConfig',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerLinkPaymentProviderConfigRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubPaymentsCreateOrderPaymentPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerCreateOrderPaymentRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerCreateOrderPaymentRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Payments/CreateOrderPayment',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerCreateOrderPaymentRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubPaymentsRefundOrderPaymentPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerRefundOrderPaymentRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerRefundOrderPaymentRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Payments/RefundOrderPayment',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerRefundOrderPaymentRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductVariantsCreateProductVariantPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerCreateProductVariantRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerCreateProductVariantRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/ProductVariants/CreateProductVariant',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerCreateProductVariantRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductVariantsDeleteProductVariantPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerDeleteProductVariantRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerDeleteProductVariantRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/ProductVariants/DeleteProductVariant',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerDeleteProductVariantRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductVariantsGetProductVariantsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetProductVariantsRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetProductVariantsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/ProductVariants/GetProductVariants',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetProductVariantsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductVariantsUpdateProductVariantPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerUpdateProductVariantRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerUpdateProductVariantRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/ProductVariants/UpdateProductVariant',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerUpdateProductVariantRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsCreateDefaultProductPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerCreateDefaultProductRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerCreateDefaultProductRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/CreateDefaultProduct',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerCreateDefaultProductRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsCreateProductPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerCreateProductRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerCreateProductRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/CreateProduct',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerCreateProductRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsDeleteProductPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerDeleteProductRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerDeleteProductRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/DeleteProduct',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerDeleteProductRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsDeleteProductsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerDeleteProductsRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerDeleteProductsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/DeleteProducts',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerDeleteProductsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsDuplicateProductsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerDuplicateProductsRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerDuplicateProductsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/DuplicateProducts',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerDuplicateProductsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsGetProductMessagePreviewPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetProductMessagePreviewRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetProductMessagePreviewRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/GetProductMessagePreview',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetProductMessagePreviewRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsGetProductPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetProductRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetProductRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/GetProduct',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetProductRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsGetProductsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetProductsRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetProductsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/GetProducts',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetProductsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsSearchProductsPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerSearchProductsRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerSearchProductsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/SearchProducts',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerSearchProductsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsUpdateDefaultProductPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerUpdateDefaultProductRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerUpdateDefaultProductRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/UpdateDefaultProduct',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerUpdateDefaultProductRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubProductsUpdateProductPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerUpdateProductRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerUpdateProductRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Products/UpdateProduct',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerUpdateProductRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubStoresCreateStorePost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerCreateStoreRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerCreateStoreRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Stores/CreateStore',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerCreateStoreRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubStoresDeleteStorePost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerDeleteStoreRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerDeleteStoreRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Stores/DeleteStore',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerDeleteStoreRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubStoresGetStorePost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetStoreRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetStoreRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Stores/GetStore',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetStoreRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubStoresGetStoresPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerGetStoresRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerGetStoresRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Stores/GetStores',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerGetStoresRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubStoresPreviewStoreTemplatesPost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerPreviewStoreTemplatesRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerPreviewStoreTemplatesRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Stores/PreviewStoreTemplates',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerPreviewStoreTemplatesRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubStoresPreviewTemplatePost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerPreviewTemplateRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerPreviewTemplateRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Stores/PreviewTemplate',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerPreviewTemplateRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubStoresUpdateStorePost = function (_a, opts) {
        var travisBackendControllersSleekflowControllersCommerceHubControllerUpdateStoreRequest = _a.travisBackendControllersSleekflowControllersCommerceHubControllerUpdateStoreRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/Stores/UpdateStore',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersSleekflowControllersCommerceHubControllerUpdateStoreRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    CommerceHubApi.prototype.commerceHubWebhookOnPaymentCompletedPost = function (_a, opts) {
        var travisBackendSleekflowCommerceHubDomainModelsOnPaymentCompletedWebhookPayload = _a.travisBackendSleekflowCommerceHubDomainModelsOnPaymentCompletedWebhookPayload;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/CommerceHub/WebhookOnPaymentCompleted',
            method: 'POST',
            headers: headers,
            body: travisBackendSleekflowCommerceHubDomainModelsOnPaymentCompletedWebhookPayload,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return CommerceHubApi;
}(runtime_1.BaseAPI));
exports.CommerceHubApi = CommerceHubApi;
